import React, { useState } from 'react'
import Form, { useForm } from '../../../../components/Form'
import Button from '../../../../components/ui/Button'
import SocietyHeading from '../../../../layout/SocietyHeading'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import SocietyPageLayout from '../../../../layout/SocietyPageLayout'
import { captureException } from '@sentry/react'
import Users from '../../../ticketing/utils/users'
import { CREATE_USER_FORM_FIELDS } from '../UniversalSignIn'

const ResetPasswordForm = connect()(({ resetPasswordToken, dispatch }) => {
  const form = useForm(CREATE_USER_FORM_FIELDS, {})
  const [errorMessage, setErrorMessage] = useState(null)

  async function handleSubmit() {
    const { password, passwordConfirmation } = form.values

    if (form.validate()) {
      try {
        const user = await Users.resetPassword({
          password,
          passwordConfirmation,
          token: resetPasswordToken,
        })
        const email = user['data']['attributes']['primaryEmail']
        const account = await Users.authenticate({ email, password })

        dispatch(actions.setUser(account))
      } catch (error) {
        if (error.status < 500) {
          setErrorMessage(error.response.errors.message)
        } else {
          setErrorMessage('Something went wrong. Please try again later.')
          captureException(error)
        }
      }
    }
  }

  return (
    <SocietyPageLayout title="Create Your Account">
      <section className="p-5 mx-auto space-y-10 bg-white shadow pb-7 sm:w-2/3">
        <SocietyHeading>Set a new password</SocietyHeading>

        <section className="space-y-5">
          <Form {...form} onSubmit={handleSubmit} />
        </section>

        <footer className="relative pb-3">
          <Button
            type="primary"
            label="Continue"
            size="xl"
            width="full"
            onClick={handleSubmit}
          />

          {errorMessage && (
            <div className="absolute inset-x-0 text-center top-full text-danger">
              {errorMessage}
            </div>
          )}
        </footer>
      </section>
    </SocietyPageLayout>
  )
})

export default ResetPasswordForm
